import { path } from 'ramda';

export const getConvention = path(['conventions', 'convention']);
export const getLoading = path(['conventions', 'isLoading']);
export const getAcknowledgeStatus = path(['conventions', 'acknowledge']);
export const getUrlError=path(['conventions', 'urlError']);
